// AUTO-GENERATED by scripts/generate-avatar-urls.js — do not edit. Run "npm run generate:avatars" when adding/removing avatars.

import avatar1 from '@/assets/avatars/avatar1.png?url';
import avatar2 from '@/assets/avatars/avatar2.png?url';
import avatar3 from '@/assets/avatars/avatar3.png?url';
import avatar4 from '@/assets/avatars/avatar4.png?url';
import avatar5 from '@/assets/avatars/avatar5.png?url';
import avatar6 from '@/assets/avatars/avatar6.png?url';
import avatar7 from '@/assets/avatars/avatar7.png?url';
import avatar8 from '@/assets/avatars/avatar8.png?url';
import avatar9 from '@/assets/avatars/avatar9.png?url';
import avatar10 from '@/assets/avatars/avatar10.png?url';

export const avatarUrls: Record<string, string> = {
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5,
    avatar6,
    avatar7,
    avatar8,
    avatar9,
    avatar10,
};
